import { ROOM_REMOVE } from '../constants'

const updateRemovedRooms = (value, dispatch) => dispatch({ type: ROOM_REMOVE, value })

export default value => dispatch => updateRemovedRooms(value, dispatch)
